/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type MyDesignServicesFeaturedProductsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MyDesignServicesFeaturedProductsQuery = {
    __typename: 'Query';
    myDesignServicesFeaturedProducts: Array<{
        __typename: 'MyDesignServicesFeaturedProduct';
        mpvId: string;
        name: string;
        imageUrl: string;
        position: number;
        price: {
            __typename: 'ExpertServicePrice';
            currency: string;
            listPriceCents: { __typename: 'PriceDetail'; taxed: number; untaxed: number };
        };
    }>;
};

export const MyDesignServicesFeaturedProductsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'MyDesignServicesFeaturedProducts' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myDesignServicesFeaturedProducts' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'mpvId' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                                { kind: 'Field', name: { kind: 'Name', value: 'position' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'price' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'currency' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'listPriceCents' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'taxed' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'untaxed',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useMyDesignServicesFeaturedProductsQuery__
 *
 * To run a query within a React component, call `useMyDesignServicesFeaturedProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyDesignServicesFeaturedProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyDesignServicesFeaturedProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMyDesignServicesFeaturedProductsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        MyDesignServicesFeaturedProductsQuery,
        MyDesignServicesFeaturedProductsQueryVariables
    >
) {
    return Apollo.useQuery<
        MyDesignServicesFeaturedProductsQuery,
        MyDesignServicesFeaturedProductsQueryVariables
    >(MyDesignServicesFeaturedProductsDocument, baseOptions);
}
export function useMyDesignServicesFeaturedProductsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        MyDesignServicesFeaturedProductsQuery,
        MyDesignServicesFeaturedProductsQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        MyDesignServicesFeaturedProductsQuery,
        MyDesignServicesFeaturedProductsQueryVariables
    >(MyDesignServicesFeaturedProductsDocument, baseOptions);
}
export type MyDesignServicesFeaturedProductsQueryHookResult = ReturnType<
    typeof useMyDesignServicesFeaturedProductsQuery
>;
export type MyDesignServicesFeaturedProductsLazyQueryHookResult = ReturnType<
    typeof useMyDesignServicesFeaturedProductsLazyQuery
>;
export type MyDesignServicesFeaturedProductsQueryResult = Apollo.QueryResult<
    MyDesignServicesFeaturedProductsQuery,
    MyDesignServicesFeaturedProductsQueryVariables
>;
